/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-12 16:37:22
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/Stock/SimpleProductStockSection.tsx
 */
import React from 'react';
import Stock from '../../Components/Stock/Stock';
// import {
//   setStock,
//   getStockSubCollapseData,
//   onSalesChannelAvailableChange,
//   onSalesChannelPresaleChange,
//   onSubCollapseChange,
// } from '../Slice';
// import { EnumProductType } from 'src/types/common/product';
// import { checkQuantityAndLeftValid } from 'src/pages/ProductEditor/tools/commonDataCheck';

const StockSection = (props) => {
  const { title = '', secondTitle = '', form, uuid, disabled } = props;

  return (
    <Stock
      form={form}
      inventoryUuid={uuid}
      secondTitle={secondTitle}
      title={title}
      disabled={disabled}
      //warehouses={warehouses}
      // setData={setData}
      // type={EnumProductType.Simple}
      // maximum={999999999}
      // quotaAmount={99999999}
      // onSalesChannelAvailableChange={_onSalesChannelAvailableChange}
      // onSalesChannelPresaleChange={_onSalesChannelPresaleChange}
      // salesChannelAvailableQuantity={salesChannelAvailableQuantity}
      // salesChannelAvailablePresaleQuantity={
      //   salesChannelAvailablePresaleQuantity
      // }
      // checkQuantityAndLeftValid={checkQuantityAndLeftValid}
      // //checkPresaleQuantityStockLeftAndValid={checkQuantityAndLeftValid}
      // salesChannelAvailableQuantityOpen={salesChannelAvailableQuantityOpen}
      // salesChannelAvailablePresaleQuantityOpen={
      //   salesChannelAvailablePresaleQuantityOpen
      // }
      // onSubCollapseChange={handleOnCollapseChange}
    />
  );
};
export default StockSection;
